export default "__VITE_ASSET__BWYyy5yf__"